import type {InputHTMLAttributes} from "react";
import {Controller, useFormContext} from "react-hook-form";

import {FieldWrapper} from "@pg-design/inputs-module";
import {Input} from "@pg-design/inputs-v2-module";

interface IProps extends Partial<InputHTMLAttributes<HTMLInputElement>> {
    label?: string;
    name: string;
}

export const InputField = (props: IProps) => {
    const {label, required, ...inputProps} = props;

    const {control} = useFormContext();

    return (
        <Controller
            control={control}
            name={props.name}
            render={({field, fieldState}) => {
                const error: string | undefined = fieldState.error?.message;

                return (
                    <FieldWrapper labelContent={label} fieldState={!!error ? "error" : "default"} message={error} required={required}>
                        <Input error={!!error} {...inputProps} {...field} />
                    </FieldWrapper>
                );
            }}
        />
    );
};
import type {InputHTMLAttributes} from "react";
import {Controller, useFormContext} from "react-hook-form";

import {FieldWrapper} from "@pg-design/inputs-module";
import {Input} from "@pg-design/inputs-v2-module";

interface IProps extends Partial<InputHTMLAttributes<HTMLInputElement>> {
    label?: string;
    name: string;
}

export const InputField = (props: IProps) => {
    const {label, required, ...inputProps} = props;

    const {control} = useFormContext();

    return (
        <Controller
            control={control}
            name={props.name}
            render={({field, fieldState}) => {
                const error: string | undefined = fieldState.error?.message;

                return (
                    <FieldWrapper labelContent={label} fieldState={!!error ? "error" : "default"} message={error} required={required}>
                        <Input error={!!error} {...inputProps} {...field} />
                    </FieldWrapper>
                );
            }}
        />
    );
};
